import { render, staticRenderFns } from "./BookingResponsesList.vue?vue&type=template&id=140691ec"
import script from "./BookingResponsesList.vue?vue&type=script&lang=js"
export * from "./BookingResponsesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports